import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6a9f974f&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9f974f')) {
      api.createRecord('6a9f974f', component.options)
    } else {
      api.reload('6a9f974f', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6a9f974f&", function () {
      api.rerender('6a9f974f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-47nv6WJ24rFeb/JS/imageCarousel.vue"
export default component.exports